import { FormControl } from "@angular/forms";

export function emailValidator() {
    return (control: FormControl) => {
      const value = control.value;
      if (!value) {
        return null; 
      }

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailPattern.test(value)) {
        return { invalidEmail: true };
      }

      return null;
    };
  }